'use client';

import { useMsal } from '@azure/msal-react';
import { useRestCall } from '@common';
import { IEmployeeDetails, NEXT_REST_ENTITY } from '@common/interfaces';
import { EmployeeDetailsProvider } from '@components/common-components/Provider/EmployeeDetailsProvider';
import { LoadingSpinner } from '@repo/ui/components';
import { useEffect, useState } from 'react';

export interface IEmployeeDetailsProps {
  isSalesRoot?: boolean;
  children: React.ReactNode;
}

export const EmployeeDetails = ({ children, isSalesRoot = false }: IEmployeeDetailsProps) => {
  const [employeeDetails, setEmployeeDetails] = useState<IEmployeeDetails>(null);
  const { accounts } = useMsal();
  let dealerRoleType = 'DEFAULT';
  const email = accounts?.[0]?.username ?? null;
  const { data: marginUser, loading } = useRestCall(NEXT_REST_ENTITY.MARGIN_AUTH, {
    method: 'GET',
    body: { email },
    nextOptions: { revalidate: 60 },
    defaultLoading: true,
  });
  const { data: independentDealerData, loading: independentDealerLoading } = useRestCall(
    NEXT_REST_ENTITY.INDEPENDENT_DEALER,
    {
      method: 'GET',
      body: { email },
      nextOptions: { revalidate: 60 },
      skip: !isSalesRoot,
      defaultLoading: true,
    }
  );
  if (independentDealerData) {
    dealerRoleType = 'INDEPENDENT_DEALER';
  }

  useEffect(() => {
    if (!loading && !independentDealerLoading && marginUser) {
      setEmployeeDetails({
        isAdminAllowed: marginUser?.isAdminAllow,
        isMargin: marginUser?.isMargin,
        isMarginAllowed: marginUser?.isMarginAllow,
        isIndependentDealerAllowed: marginUser?.isIndependentDealerAllow,
        isTestUser: marginUser?.isTestUser,
        dealerRoleType: dealerRoleType,
      });
    }
  }, [independentDealerLoading, loading, marginUser, independentDealerData]);

  if (loading || independentDealerLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  return <EmployeeDetailsProvider employeeDetails={employeeDetails}>{children}</EmployeeDetailsProvider>;
};
